import React, { useState, useEffect } from 'react';
import { translate } from '@td/shared_utils';
import './styles.scss';
import NewEditIcon from '../icons/components/new-edit-icon';
import SAME_DAY_VISITS_QUERY from './same-day-visit-query.graphql';
import UPDATE_SAME_DAY_VISITS_TOGGLE from './update-same-day-scheduling-toggle.graphql';
import { useMutation, useQuery } from '@apollo/client';

const SameDayVisits = ({ providerId }) => {
  const [checked, setChecked] = useState(false);
  const [disabledForThisProvider, setDisabledForThisProvider] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [currentToggleState, setCurrentToggleState] = useState(false);
  const [currentDisabledState, setCurrentDisabledState] = useState(false);

  const { data } = useQuery(SAME_DAY_VISITS_QUERY, {
    variables: { providerId: providerId }
  });

  const [updateSameDayVisitsToggle, { loading: isLoading }] = useMutation(UPDATE_SAME_DAY_VISITS_TOGGLE, {
    onCompleted: data => {
      data && data.sameDaySchedulingToggle && data.sameDaySchedulingToggle.success && handleCancel();
    }
  });

  const Loader = () => (
    <div className="loaderContainer">
      <img src="/assets/ajax_loader_66.gif" alt="Loading..." />
    </div>
  );

  useEffect(() => {
    if (data) {
      if (data && data.providerSettings && data.providerSettings.visitLeadTimeOptInFlg === 'Y') {
        setChecked(true);
      } else {
        setChecked(false);
      }

      if (data && data.providerSettings && data.providerSettings.disableSameDaySchedulingFlg === 'Y') {
        setDisabledForThisProvider(true);
      } else {
        setDisabledForThisProvider(false);
      }
    }
  }, [data]);

  const handleEditClick = () => {
    setIsEditing(true);
    setCurrentToggleState(checked);
    setCurrentDisabledState(disabledForThisProvider);
  };

  const handleCancel = () => {
    setIsEditing(false);
  };

  const handleOnChange = event => {
    setCurrentToggleState(event.target.checked);
  };

  const handleDisableChange = event => {
    setCurrentDisabledState(event.target.checked);
  };

  console.log('currentDisabledState0', currentDisabledState);
  const handleSave = () => {
    console.log('currentDisabledState1', currentDisabledState);
    updateSameDayVisitsToggle({
      variables: {
        providerId: providerId,
        toggleValue: currentToggleState ? 'Y' : 'N',
        disableSameDayFlg: currentDisabledState ? 'Y' : 'N'
      }
    });
    setChecked(currentToggleState);
    setDisabledForThisProvider(currentDisabledState);
  };

  if (!data) return null;
  return (
    <React.Fragment>
      <div className="sameDayVisits">
        <div className="sameDayVisitsHeading">{translate(null, 'providers_schedule.same_day_visits', 'title')}</div>
        {!isEditing && !isLoading && (
          <div onClick={handleEditClick} className="editActionWrapper">
            <span className="editAction">{translate(null, 'provider', 'edit')}</span>
            <NewEditIcon />
          </div>
        )}
      </div>

      <div className="sameDayVisitContent">
        {!isEditing && !isLoading && (
          <div className="view">
            <p className="viewText">
              {checked
                ? translate(null, 'provider.same_day_visits', 'same_day_visit_on')
                : translate(null, 'provider.same_day_visits', 'same_day_visit_off')}
            </p>

            <p className="viewText">
              {disabledForThisProvider
                ? translate(null, 'provider.same_day_visits', 'disabled_for_this_provider')
                : translate(null, 'provider.same_day_visits', 'enabled_for_this_provider')}
            </p>
          </div>
        )}
        {isEditing && (
          <div className="edit">
            {isLoading ? (
              <Loader />
            ) : (
              <React.Fragment>
                <div>
                  <div className="sameDayVisitsFieldWrapper">
                    <p className="sameDayVisitsLabel">
                      {translate(null, 'provider.same_day_visits', 'accept_same_day_visit_request')}
                    </p>

                    <div className="toggleSwitchWrapperContainer">
                      <div className="toggleAndStatus">
                        <div className="toggleSwitchWrapper">
                          <label className="toggleSwitch">
                            <input type="checkbox" onChange={handleOnChange} checked={currentToggleState}/>
                            <span className="toggleSlider round" />
                          </label>
                        </div>
                        <span className="toggleStatus">{currentToggleState ? 'On' : 'Off'}</span>
                      </div>
                      <div>{translate(null, 'provider.same_day_visits', 'if_same_day_visits_turned_off')}</div>
                    </div>
                  </div>
                  <div className="disableSameDayVisitsWrapper">
                    <p className="disableSameDayVisitsLabel">
                      {translate(null, 'provider.same_day_visits', 'disable_for_this_provider')}
                    </p>
                    <input
                      id="disable_same_day_visit"
                      type="checkbox"
                      checked={currentDisabledState}
                      onChange={handleDisableChange}
                    />
                  </div>
                </div>
                <div className="editButtons">
                  <div className="cancel" onClick={handleCancel}>
                    {translate(null, 'provider.same_day_visits', 'cancel')}
                  </div>
                  <div className="save" onClick={handleSave}>
                    {translate(null, 'provider.same_day_visits', 'save')}
                  </div>
                </div>
              </React.Fragment>
            )}
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default SameDayVisits;
